/**
 * Layout Width Constants
 * 
 * Unified width constants for consistent layout across the application
 */

export const LAYOUT_WIDTH = {
  /** Default width for most pages */
  DEFAULT: 640,
  
  /** List pages (users, groups, etc.) */
  LIST: 640,
  
  /** Detail pages (user details, profile, etc.) */
  DETAIL: 640,
  
  /** Wide pages (admin, analytics, etc.) */
  WIDE: 1200,
  
  /** Auth pages (login, etc.) */
  AUTH: 420,
} as const

export type LayoutWidth = typeof LAYOUT_WIDTH[keyof typeof LAYOUT_WIDTH]
